import { Controller } from "@hotwired/stimulus"
import { parse_color } from "utils"
import { Chart } from "chart.js"

export default class extends Controller {
  static values = {
    datasets: Array,
    labels: Array
  }

  connect() {
    this.initializeChart()
  }

  initializeChart() {
    const canvas = this.element.querySelector("#signals-investigated-chart")
    if (!canvas) return

    new Chart(canvas.getContext("2d"), {
      type: "line",
      data: {
        datasets: this.parsedDatasets,
        labels: this.labelsValue
      },
      options: {
        plugins: {
          legend: {
            display: true,
            align: "center"
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              drawTicks: false
            },
            ticks: {
              min: 0,
              stepSize: 1,
              suggestedMax: 20,
              maxTicksLimit: 10,
              padding: 10,
              userCallback: function(value) {
                return Number(value).toLocaleString()
              }
            }
          }],
          xAxes: [{
            gridLines: {
              drawTicks: false,
            },
            ticks: {
              padding: 10,
            }
          }]
        }
      }
    })
  }

  get parsedDatasets() {
    return this.datasetsValue.map(dataset => {
      const parsed = { ...dataset }
      if (parsed.borderColor && parsed.borderColor.startsWith("--")) {
        parsed.borderColor = parse_color(parsed.borderColor)
      }
      if (parsed.backgroundColor && typeof parsed.backgroundColor === "string" && parsed.backgroundColor.startsWith("--")) {
        parsed.backgroundColor = parse_color(parsed.backgroundColor)
      }
      return parsed
    })
  }
}
